/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SecurityDashboardLayoutPutRequest,
  SecurityDashboardLayoutResponse,
} from '../models/index';
import {
    SecurityDashboardLayoutPutRequestFromJSON,
    SecurityDashboardLayoutPutRequestToJSON,
    SecurityDashboardLayoutResponseFromJSON,
    SecurityDashboardLayoutResponseToJSON,
} from '../models/index';

export interface GetLayoutRequest {
    tenantId: string;
}

export interface PutLayoutRequest {
    tenantId: string;
    securityDashboardLayoutPutRequest: SecurityDashboardLayoutPutRequest;
}

/**
 * SecurityDashboardApi - interface
 * 
 * @export
 * @interface SecurityDashboardApiInterface
 */
export interface SecurityDashboardApiInterface {
    /**
     * Returns the persisted layout for the authenticated user in the given tenant. **204 No Content:** when no layout has been saved (client uses default layout). **Concurrency:** last write wins; there is no ETag/If-Match contract on this resource. 
     * @summary Get Security Dashboard layout
     * @param {string} tenantId Tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityDashboardApiInterface
     */
    getLayoutRaw(requestParameters: GetLayoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityDashboardLayoutResponse>>;

    /**
     * Returns the persisted layout for the authenticated user in the given tenant. **204 No Content:** when no layout has been saved (client uses default layout). **Concurrency:** last write wins; there is no ETag/If-Match contract on this resource. 
     * Get Security Dashboard layout
     */
    getLayout(requestParameters: GetLayoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityDashboardLayoutResponse>;

    /**
     * Persists the layout JSON for the authenticated user in the given tenant. Request body must be `{ \"layout\": { ... } }` with a `version` field and `widgets` array. Version **5** is current: include `dashboardDateRange` (preset or custom, not inherited) and per-widget `dateRange` (`preset`, `custom`, or `inherited` to follow the dashboard range). Versions 1–4 are accepted and normalized to version 5 when valid. **400:** malformed JSON, missing `layout`, or payload larger than 64KB after canonicalization. **422:** structural validation failure. 
     * @summary Save Security Dashboard layout
     * @param {string} tenantId Tenant id
     * @param {SecurityDashboardLayoutPutRequest} securityDashboardLayoutPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityDashboardApiInterface
     */
    putLayoutRaw(requestParameters: PutLayoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityDashboardLayoutResponse>>;

    /**
     * Persists the layout JSON for the authenticated user in the given tenant. Request body must be `{ \"layout\": { ... } }` with a `version` field and `widgets` array. Version **5** is current: include `dashboardDateRange` (preset or custom, not inherited) and per-widget `dateRange` (`preset`, `custom`, or `inherited` to follow the dashboard range). Versions 1–4 are accepted and normalized to version 5 when valid. **400:** malformed JSON, missing `layout`, or payload larger than 64KB after canonicalization. **422:** structural validation failure. 
     * Save Security Dashboard layout
     */
    putLayout(requestParameters: PutLayoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityDashboardLayoutResponse>;

}

/**
 * 
 */
export class SecurityDashboardApi extends runtime.BaseAPI implements SecurityDashboardApiInterface {

    /**
     * Returns the persisted layout for the authenticated user in the given tenant. **204 No Content:** when no layout has been saved (client uses default layout). **Concurrency:** last write wins; there is no ETag/If-Match contract on this resource. 
     * Get Security Dashboard layout
     */
    async getLayoutRaw(requestParameters: GetLayoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityDashboardLayoutResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getLayout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/security-dashboard/layout`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityDashboardLayoutResponseFromJSON(jsonValue));
    }

    /**
     * Returns the persisted layout for the authenticated user in the given tenant. **204 No Content:** when no layout has been saved (client uses default layout). **Concurrency:** last write wins; there is no ETag/If-Match contract on this resource. 
     * Get Security Dashboard layout
     */
    async getLayout(requestParameters: GetLayoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityDashboardLayoutResponse> {
        const response = await this.getLayoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Persists the layout JSON for the authenticated user in the given tenant. Request body must be `{ \"layout\": { ... } }` with a `version` field and `widgets` array. Version **5** is current: include `dashboardDateRange` (preset or custom, not inherited) and per-widget `dateRange` (`preset`, `custom`, or `inherited` to follow the dashboard range). Versions 1–4 are accepted and normalized to version 5 when valid. **400:** malformed JSON, missing `layout`, or payload larger than 64KB after canonicalization. **422:** structural validation failure. 
     * Save Security Dashboard layout
     */
    async putLayoutRaw(requestParameters: PutLayoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityDashboardLayoutResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling putLayout().'
            );
        }

        if (requestParameters['securityDashboardLayoutPutRequest'] == null) {
            throw new runtime.RequiredError(
                'securityDashboardLayoutPutRequest',
                'Required parameter "securityDashboardLayoutPutRequest" was null or undefined when calling putLayout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/security-dashboard/layout`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecurityDashboardLayoutPutRequestToJSON(requestParameters['securityDashboardLayoutPutRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityDashboardLayoutResponseFromJSON(jsonValue));
    }

    /**
     * Persists the layout JSON for the authenticated user in the given tenant. Request body must be `{ \"layout\": { ... } }` with a `version` field and `widgets` array. Version **5** is current: include `dashboardDateRange` (preset or custom, not inherited) and per-widget `dateRange` (`preset`, `custom`, or `inherited` to follow the dashboard range). Versions 1–4 are accepted and normalized to version 5 when valid. **400:** malformed JSON, missing `layout`, or payload larger than 64KB after canonicalization. **422:** structural validation failure. 
     * Save Security Dashboard layout
     */
    async putLayout(requestParameters: PutLayoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityDashboardLayoutResponse> {
        const response = await this.putLayoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
